var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2155 1.28183C11.6123 1.40085 11.8374 1.81896 11.7184 2.21571L10.208 7.2502H16.642L18.2816 1.78469C18.4007 1.38794 18.8188 1.1628 19.2155 1.28183C19.6123 1.40085 19.8374 1.81896 19.7184 2.21571L18.208 7.2502H22C22.4142 7.2502 22.75 7.58598 22.75 8.0002C22.75 8.41441 22.4142 8.7502 22 8.7502H17.758L15.808 15.2502H22C22.4142 15.2502 22.75 15.586 22.75 16.0002C22.75 16.4144 22.4142 16.7502 22 16.7502H15.358L13.7184 22.2157C13.5993 22.6125 13.1812 22.8376 12.7845 22.7186C12.3877 22.5995 12.1626 22.1814 12.2816 21.7847L13.792 16.7502H7.35802L5.71837 22.2157C5.59935 22.6125 5.18123 22.8376 4.78449 22.7186C4.38774 22.5995 4.16261 22.1814 4.28163 21.7847L5.79198 16.7502H2C1.58579 16.7502 1.25 16.4144 1.25 16.0002C1.25 15.586 1.58579 15.2502 2 15.2502H6.24198L8.19198 8.7502H2C1.58579 8.7502 1.25 8.41441 1.25 8.0002C1.25 7.58598 1.58579 7.2502 2 7.2502H8.64198L10.2816 1.78469C10.4007 1.38794 10.8188 1.1628 11.2155 1.28183ZM9.75802 8.7502L7.80802 15.2502H14.242L16.192 8.7502H9.75802Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.31dd71769a907da5ce305e5f0ad94ca6.svg";
export { ForwardRef as ReactComponent };